// extracted by mini-css-extract-plugin
export default {"heading":"dialog_heading__QlL8z","bgImg":"dialog_bgImg__vghK3","SaveButton":"dialog_SaveButton__YHVFo","closeIcon":"dialog_closeIcon__sQOQd"};